import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { App } from "./App";
import { I18nProvider } from "./i18n";
import "./styles.css";

// Nach einem Deploy existieren alte Lazy-Chunks nicht mehr — ein offener Tab
// lädt sich dann einmal neu, statt mit Fehlern liegenzubleiben.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  window.location.reload();
});

// Data-Router statt <BrowserRouter>: nur damit kann eine Seite Navigationen anhalten
// (useBlocker — laufende Uploads auf der Tour-Seite). Die Routen selbst bleiben als
// <Routes> in App.tsx; hier gibt es nur die eine Catch-all-Route.
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

createRoot(document.getElementById("root")!).render(
  <I18nProvider>
    <RouterProvider router={router} />
  </I18nProvider>,
);
